// extracted by mini-css-extract-plugin
export var cite = "bD_fJ";
export var inlineSourceLink = "bD_fH";